import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=26806c0c"
import script from "./transactionDetail.vue?vue&type=script&lang=js"
export * from "./transactionDetail.vue?vue&type=script&lang=js"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=26806c0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports